import React from 'react';
import { Texto } from './Texto';
export const RenderAditionalInfo = ({ aditionalInfo, align, fontSize, bold }) => React.createElement(Texto, { texto: aditionalInfo, align: align, fontSize: fontSize, bold: bold });



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/AditionalInfo.tsx
// module id = 525
// module chunks = 0